import { configureStore } from "@reduxjs/toolkit";
import {
  useDispatch,
  useSelector,
  type TypedUseSelectorHook,
} from "react-redux";
import authReducer from "./authSlice";
import projectsReducer from "./projectsSlice";
import matchPropertiesReducer from "./matchPropertiesSlice";
import featureFlagsReducer from "./featureFlagsSlice";
import requestsReducer from "./requestsSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    projects: projectsReducer,
    matchProperties: matchPropertiesReducer,
    featureFlags: featureFlagsReducer,
    requests: requestsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
